// extracted by mini-css-extract-plugin
module.exports = {"donationsHistoryTab":"DonationsHistoryTab_donationsHistoryTab__p6lah","title":"DonationsHistoryTab_title__18aqK","showMoreBtn":"DonationsHistoryTab_showMoreBtn__2Ar0Z"};